import { TranslatableInputButtons } from '@pbk-web/ui';
import type { FC } from 'react';

import { useEditorChrome } from '../../core/context/EditorChromeContext';
import { useEditorProps } from '../../core/context/EditorPropsContext';
import { keepSelection } from '../../ui/styles';
import { useMultiLanguage } from './MultiLanguageContext';

/**
 * The language pills (shared `TranslatableInputButtons`); only while multi-language is on and the editor is active.
 * - Placed by the host: the toolbar in rich mode, beside the text in plain mode.
 * - Mouse-down is cancelled so switching language keeps the caret in the editor.
 */
export const LanguageButtons: FC<{ className?: string }> = ({ className = '' }) => {
  const multiLanguage = useMultiLanguage();
  const { focused } = useEditorChrome();
  const { error, errorState } = useEditorProps();
  if (!multiLanguage || !focused) return null;

  return (
    <div className={`flex shrink-0 items-center gap-1 ${className}`} onMouseDown={keepSelection}>
      <TranslatableInputButtons
        selected={multiLanguage.currentLanguage}
        errorState={errorState || !!error}
        onChange={multiLanguage.setCurrentLanguage}
      />
    </div>
  );
};
